import React from 'react';
import { Mail, Linkedin } from 'lucide-react';
import { Link } from 'react-scroll';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo">
              <img 
                src="https://customer-assets.emergentagent.com/job_22049afd-70cd-4eda-9ae4-f1c9d8a02585/artifacts/epd28g0n_ido-consulting-notext-large.png"
                alt="IDO Logo"
                className="footer-logo-image"
                loading="lazy"
              />
              <div>
                <h4>IDO</h4>
                <p className="footer-tagline">Adaptive</p>
              </div>
            </div>
            <p className="footer-description">
              Adaptive Intelligence. By Design.
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <h5>Services</h5>
              <ul>
                <li>
                  <Link to="capabilities" smooth={true} duration={800} offset={-80} style={{ cursor: 'pointer' }}>
                    Adaptive Governance
                  </Link>
                </li>
                <li>
                  <Link to="capabilities" smooth={true} duration={800} offset={-80} style={{ cursor: 'pointer' }}>
                    Organizational Design
                  </Link>
                </li>
                <li>
                  <Link to="capabilities" smooth={true} duration={800} offset={-80} style={{ cursor: 'pointer' }}>
                    Workforce Intelligence
                  </Link>
                </li>
                <li>
                  <Link to="capabilities" smooth={true} duration={800} offset={-80} style={{ cursor: 'pointer' }}>
                    Operational Durability
                  </Link>
                </li>
                <li>
                  <Link to="capabilities" smooth={true} duration={800} offset={-80} style={{ cursor: 'pointer' }}>
                    Leadership Stewardship
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer-column">
              <h5>Company</h5>
              <ul>
                <li>
                  <Link to="hero" smooth={true} duration={800} offset={-80} style={{ cursor: 'pointer' }}>
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="approach" smooth={true} duration={800} offset={-80} style={{ cursor: 'pointer' }}>
                    Approach
                  </Link>
                </li>
                <li>
                  <Link to="capabilities" smooth={true} duration={800} offset={-80} style={{ cursor: 'pointer' }}>
                    Services
                  </Link>
                </li>
                <li>
                  <Link to="about" smooth={true} duration={800} offset={-80} style={{ cursor: 'pointer' }}>
                    Insights
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer-column">
              <h5>Connect</h5>
              <div className="footer-social">
                <a 
                  href="https://outlook.office.com/bookwithme/user/4526d5f0831940e5bde7b640ab309b68%40idoconsulting.ca?anonymous&ismsaljsauthenabled=true" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link"
                  title="Book a Meeting"
                >
                  <Mail size={20} />
                </a>
                <a 
                  href="https://www.linkedin.com/company/ido-adaptive/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link"
                  title="LinkedIn"
                >
                  <Linkedin size={20} />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 IDO - Adaptive Intelligence Systems. All rights reserved.</p>
          <div className="footer-legal">
            <a href="#">Privacy Policy</a>
            <span>•</span>
            <a href="#">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;